// extracted by mini-css-extract-plugin
export var button = "_7p-0";
export var icon = "_7p-1";